/* eslint-disable import/no-cycle */
import React from 'react'

import { useTranslation } from 'react-i18next'
import { withTheme } from 'styled-components'

import { Label } from 'components/forms/components/styled'
import Icon, { IconNames } from 'components/icons'
import Input from 'components/input'
import { RadioGroup } from 'components/radio-button'
import e2eClasses from 'helpers/automation'
import { withErrorClassName } from 'hoc/withErrorClassName'
import NAMESPACES from 'localization/constants/namespaces'

import { InputContainer, InputRow } from '../styled'
import { ids } from './ids'
import {
  SectionContainer,
  TitleWrapper,
  SectionTitle,
  IconWrapper,
  RadioGroupContainer
} from './styled'

const InputWithErrorClassName = withErrorClassName(Input)

const ContactDataFields = ({
  theme,
  formikBag: { handleChange, handleBlur, setFieldValue, setFieldTouched },
  sectionProps: { values = {}, touched = {}, errors = {} }
}) => {
  const { t } = useTranslation(NAMESPACES.CORPORATE_AGREEMENTS)
  return (
    <SectionContainer>
      <TitleWrapper e2eClass={e2eClasses('corporate.contactTitle')}>
        <IconWrapper>
          <Icon name={IconNames.Account} color={theme.colors.blue} size={24} />
        </IconWrapper>
        <SectionTitle>{t('agreements.request.contact-title')}</SectionTitle>
      </TitleWrapper>
      <InputRow>
        <InputContainer>
          <InputWithErrorClassName
            light
            e2eClass={e2eClasses('corporate.name')}
            name="contactFields.contactName"
            labelFontSize="16px"
            label={t('label.name')}
            placeholder={t('label.name')}
            value={values.contactName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.contactName && errors.contactName}
            id={ids.corporateName}
            role="textbox"
          />
        </InputContainer>
        <InputContainer>
          <InputWithErrorClassName
            light
            labelFontSize="16px"
            e2eClass={e2eClasses('corporate.lastName')}
            name="contactFields.contactLastname"
            label={t('label.lastname')}
            placeholder={t('label.lastname')}
            value={values.contactLastname}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.contactLastname && errors.contactLastname}
            id={ids.corporateLastName}
            role="textbox"
          />
        </InputContainer>
        <InputContainer>
          <InputWithErrorClassName
            light
            e2eClass={e2eClasses('corporate.jobtTitle')}
            name="contactFields.jobTitle"
            labelFontSize="16px"
            label={t('agreements.request.contact-job-title.label')}
            placeholder={t('agreements.request.contact-job-title.label')}
            value={values.jobTitle}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.jobTitle && errors.jobTitle}
            id={ids.corporateJobTitle}
            role="textbox"
          />
        </InputContainer>
      </InputRow>
      <InputRow>
        <InputContainer>
          <InputWithErrorClassName
            light
            e2eClass={e2eClasses('corporate.email')}
            name="contactFields.email"
            labelFontSize="16px"
            label={t('label.email')}
            placeholder={t('label.email')}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && errors.email}
            id={ids.corporateEmail}
            role="textbox"
          />
        </InputContainer>
        <InputContainer>
          <InputWithErrorClassName
            light
            e2eClass={e2eClasses('corporate.phone')}
            name="contactFields.phoneNumber"
            labelFontSize="16px"
            label={t('label.phone')}
            placeholder={t('label.phone')}
            value={values.phoneNumber}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.phoneNumber && errors.phoneNumber}
            id={ids.corporatePhone}
            role="textbox"
          />
        </InputContainer>
        <InputContainer /> {/*Needed due to flex=0.32 css value*/}
      </InputRow>
      <InputRow isLast>
        <InputContainer flexDirection="column" justifyContent="space-between" alignSelf="stretch">
          <Label e2eClass={e2eClasses('corporate.directFlights')} fontSize="16px">
            {t('agreements.request.contact-direct-travel-management.label')}
          </Label>
          <RadioGroupContainer>
            <RadioGroup
              fontSize="16px"
              paddingTop={'0'}
              color={theme.colors.doveGray}
              name="contactFields.directTravelsManagement"
              options={[
                {
                  value: 'true',
                  e2eClass: e2eClasses('corporate.labelYes'),
                  text: t('label.yes'),
                  selected: values.directTravelsManagement
                },
                {
                  value: 'false',
                  e2eClass: e2eClasses('corporate.labelNo'),
                  text: t('label.no'),
                  selected: !values.directTravelsManagement
                }
              ]}
              onChange={(value, name) => {
                setFieldValue(name, value === 'true' ? true : false) //Workarounds boolean as string due to html attr
                setFieldTouched(name, true)
              }}
              horizontal
            />
          </RadioGroupContainer>
        </InputContainer>
        <InputContainer>
          {!values.directTravelsManagement && (
            <InputWithErrorClassName
              light
              e2eClass={e2eClasses('corporate.travelAgencyName')}
              name="contactFields.travelAgencyName"
              labelFontSize="16px"
              label={t('agreements.request.contact-direct-travel-agency.name.label')}
              placeholder={t('agreements.request.contact-direct-travel-agency.name.placeholder')}
              value={values.travelAgencyName}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.travelAgencyName && errors.travelAgencyName}
              id={ids.corporateTravelAgency}
              role="textbox"
            />
          )}
        </InputContainer>
        <InputContainer /> {/*Needed due to flex=0.32 css value*/}
      </InputRow>
    </SectionContainer>
  )
}

export default withTheme(
  React.memo(
    ContactDataFields,
    (prevProps, { sectionProps: { values, touched, errors } }) =>
      prevProps.sectionProps.values === values &&
      prevProps.sectionProps.touched === touched &&
      prevProps.sectionProps.errors === errors
  )
)
